import classNames from "classnames";
import { ReactNode, useEffect, useState } from "react";
import { ModalComponent } from "..";
import { PaymentMethods } from "../../../utils/types";
import { PageLoader } from "../../loaders/pageLoader";

const paymentMethods: { item: ReactNode; value: PaymentMethods }[] = [
  {
    item: <img src={"/assets/images/paystack.svg"} alt="paystack" />,
    value: "paystack",
  },
];

export const PaymentSelectionModal = ({
  isModalOpen,
  onModalClose,
  title,
  children,
  canProccedToPaymentMethod,
  fetchingPayment,
  onMethodSelect,
}: {
  isModalOpen: boolean;
  onModalClose: () => void;
  title: string;
  children: ReactNode;
  canProccedToPaymentMethod: boolean;
  fetchingPayment: boolean;
  onMethodSelect: (
    method: PaymentMethods,
    setMethod: (m?: PaymentMethods) => void
  ) => void;
}) => {
  const [selectedMethod, setSelectedMethod] = useState<PaymentMethods>();
  const [step, setStep] = useState<number>(1);

  useEffect(() => {
    if (!isModalOpen) {
      setSelectedMethod(undefined);
      setStep(1);
    }
  }, [isModalOpen]);

  return (
    <ModalComponent
      isModalOpen={isModalOpen}
      onModalClose={() => {
        setSelectedMethod(undefined);
        setStep(1);
        onModalClose();
      }}
      title={step === 1 ? title : `Choose Payment Method`}
      topTitle={false}
      childrenClassName=""
      modalClassName="!min-h-[490px]"
      hasButtons={step === 1}
      proceedButtonText="Proceed"
      proceedButtonVariant="primary"
      onProceedClick={() => {
        setStep(2);
      }}
      isProceedDisabled={step !== 1 || !canProccedToPaymentMethod}
    >
      {step === 1 ? children : undefined}

      {step === 2 ? (
        <div className="flex flex-col gap-2">
          {paymentMethods?.map((method) => {
            return (
              <button
                className={classNames(
                  "p-4 border border-pry-dark-green-300/10 bg-light-green-bg rounded-[8px] w-full text-left flex items-center justify-between",
                  {
                    "!border-pry-dark-green-300/100 border-[1.5px]":
                      selectedMethod === method.value,
                  }
                )}
                key={method.value}
                type="button"
                disabled={fetchingPayment}
                onClick={() => {
                  setSelectedMethod(method.value);
                  onMethodSelect(method.value, setSelectedMethod);
                }}
              >
                {method.item}

                {fetchingPayment && selectedMethod === method.value ? (
                  <PageLoader
                    variant="spinner"
                    className="!min-h-fit !h-fit !w-fit"
                    width={16}
                    height={16}
                  />
                ) : undefined}
              </button>
            );
          })}
        </div>
      ) : undefined}
    </ModalComponent>
  );
};
